import { ETransactionTypes, ITransaction } from '../../../../../store/fetchers/users/types'

export function isIncomingTransaction(transaction: ITransaction) {
  if (!transaction) {
    return false
  }

  return (
    transaction.transaction_type === ETransactionTypes.COLLATERAL ||
    transaction.transaction_type === ETransactionTypes.REPAYMENT ||
    transaction.transaction_type === ETransactionTypes.DEPOSIT ||
    transaction.transaction_type === ETransactionTypes.EXCHANGE
  )
}

export function isPositiveTransaction(transaction: ITransaction) {
  if (!transaction) {
    return false
  }

  return (
    transaction.transaction_type === ETransactionTypes.COLLATERAL ||
    transaction.transaction_type === ETransactionTypes.PLEDGE ||
    transaction.transaction_type === ETransactionTypes.DEPOSIT ||
    transaction.transaction_type === ETransactionTypes.LOAN
  )
}
